import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { CodeIcon } from 'foundations-assets/icons/components/CodeIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { VideoAssetTypename } from '../../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService';
import { extractEmbedParametersFromAcademyUrl } from '../utils/extractEmbedParameters';
import { useEmbedModal } from '../embedModalContext';
import { useUserInfo } from '../../accounts/accountsQueries';
import { useFullLessonChirp } from '../../lessons/lessonQueries';
import { useFullShort } from '../../shortContent/shortContentQueries';
import { getIsHubSpotter } from '../../../utils/hubspotterUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CopyEmbedCodeMenuOption = ({
  language,
  url = window.location.toString()
}) => {
  const {
    userInfo
  } = useUserInfo();
  const isHubspotter = getIsHubSpotter(userInfo);
  const [isOpen, setIsOpen] = useState(false);
  const EmbedModal = useEmbedModal();
  const {
    lessonId,
    contentId,
    shortId
  } = extractEmbedParametersFromAcademyUrl(url);
  const {
    lesson
  } = useFullLessonChirp({
    lessonId: lessonId,
    skip: !lessonId
  });
  const {
    short
  } = useFullShort(shortId, !shortId);
  const lessonVideoContent = lesson === null || lesson === void 0 ? void 0 : lesson.content.find(content => content.id === contentId && content.__typename === VideoAssetTypename);
  if (!(lessonId && contentId || shortId) || !isHubspotter || lesson && !lessonVideoContent || !EmbedModal) {
    return null;
  }
  const isEmbeddable = lesson && lesson.visibility === 'PUBLIC' || short && short.visibility === 'PUBLIC';
  return /*#__PURE__*/_jsx(Tooltip, {
    title: !isEmbeddable ? I18n.text('academyCommon.embedModal.notEmbeddableTooltip') : undefined,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        block: true,
        disabled: !isEmbeddable,
        onClick: () => setIsOpen(true),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(SideNavItem, {
            disabled: !isEmbeddable,
            role: "navigation-item",
            title: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(IconHolder, {
                icon: CodeIcon,
                marginInlineStart: "-200"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyCommon.cardMenu.copyEmbedCode"
              })]
            })
          })
        })
      }), isOpen && /*#__PURE__*/_jsx(EmbedModal, {
        contentId: contentId,
        language: language,
        lessonId: lessonId,
        onClose: () => setIsOpen(false),
        shortId: shortId,
        title: (lessonVideoContent === null || lessonVideoContent === void 0 ? void 0 : lessonVideoContent.name) || (short === null || short === void 0 ? void 0 : short.name) || ''
      })]
    })
  });
};
export default CopyEmbedCodeMenuOption;